import { TypeGenerator, isString, isInteger } from '../utils/type';
import { IArgumentType } from '../functions/utils';
import { InferenceError } from '../errors';
import { IFunctionToken } from '../typings/token';


/**
 * 字符串截取函数
 * 函数需要为三个或四个参数
 * 参数1: 需要截取的目标字符串
 * 参数2: 需要截取的开始索引值
 * 参数3: 需要截取的字符串长度
 * 参数4: 文本截取策略（可选），0-模糊截取 1-精确截取
 */
export function SUBSTR(args: IArgumentType[], token: IFunctionToken) {
  const functionName = token.formatName;

  if (args.length !== 3 && args.length !== 4) {
    throw new InferenceError('function-argument-error', `${functionName} 函数的参数必须为三个或四个`, token.position);
  }

  if (!isString(args[0], false)) {
    throw new InferenceError('function-argument-error', `${functionName} 函数的第一个参数必须为 字符串 类型`, token.position);
  }

  if (!isInteger(args[1], false)) {
    throw new InferenceError('function-argument-error', `${functionName} 函数的第二个参数必须为整数类型`, token.position);
  }

  if (!isInteger(args[2], false)) {
    throw new InferenceError('function-argument-error', `${functionName} 函数的第三个参数必须为整数类型`, token.position);
  }


  if (args[3] && (!isInteger(args[3], false) || !args[3].token.isAtom || ![0, 1].includes(args[3].token.value))) {
    throw new InferenceError('function-argument-error', `${functionName} 函数的第四个参数只能为 0 或 1`, token.position);
  }

  return TypeGenerator.String();
}
